import { render, staticRenderFns } from "./FooterCell.vue?vue&type=template&id=24c8f880&scoped=true"
import script from "./FooterCell.vue?vue&type=script&lang=js"
export * from "./FooterCell.vue?vue&type=script&lang=js"
import style0 from "./FooterCell.vue?vue&type=style&index=0&id=24c8f880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c8f880",
  null
  
)

export default component.exports